var trash = "https://shopfront-cdn.tekoapis.com/static/e0fc0c2da71993c2.svg";

export { trash as default };
